module.exports = __webpack_public_path__ + "img/hi_bubble.c783859.png";